export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: 'Psycholog Warszawa Dominika Krata | Terapia dzieci, młodzieży i dorosłych',
  description:
    'Psycholog, terapeuta dzieci, młodzieży i dorosłych. Pomoc dla dzieci i młodzież na każdym etapie rozwoju.',
  author: 'Visionative',
};
